"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconConst = require("./iconConst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
  var type = props.type; // eslint-disable-next-line complexity

  var iconType = function iconType() {
    if (type === _iconConst.ERROR) {
      return _iconConst.ERROR_ICON;
    }

    if (type === _iconConst.VALID) {
      return _iconConst.VALID_ICON;
    }

    if (type === _iconConst.WARNING) {
      return _iconConst.WARNING_ICON;
    }

    if (type === _iconConst.SUCCESS) {
      return _iconConst.SUCCESS_ICON;
    }

    if (type === _iconConst.INFO) {
      return _iconConst.INFO_ICON;
    }

    if (type === _iconConst.CREDITCARD) {
      return _iconConst.CREDITCARD_ICON;
    }

    if (type === _iconConst.PAYPAL) {
      return _iconConst.PAYPAL_ICON;
    }

    if (type === _iconConst.APPLEPAY) {
      return _iconConst.APPLEPAY_ICON;
    }

    if (type === _iconConst.MASTERPASS) {
      return _iconConst.MASTERCARD_ICON;
    }

    return null;
  };

  return _react.default.createElement("span", {
    className: "field-icon-validation__content"
  }, iconType());
};

exports.Icon = Icon;
Icon.propTypes = {
  type: _propTypes.default.string.isRequired
};